import React from "react";
import {connect} from "react-redux";
import {ReduxWebcastWbsNetworkStatusType} from "@nextlot/core/webcast/redux/webcast/reducerWbsNetworkStatus";
import {ReduxStateType} from "@nextlot/core/webcast/services/DataStore";
import {ChannelEnum} from "@nextlot/core/webcast/redux/actions";


type CmpPropsType = {
    wbsCommChannel:string,
    wbsNetworkStatus:ReduxWebcastWbsNetworkStatusType,
}


const NetworkAwareBusyOverlayCmp = (props:CmpPropsType) => {
    let channelBusy = false;
    if (props.wbsCommChannel === ChannelEnum.bidding) {
        channelBusy = props.wbsNetworkStatus.biddingCommBusy;
    }
    else if (props.wbsCommChannel === ChannelEnum.chat) {
        channelBusy = props.wbsNetworkStatus.chatCommBusy;
    }
    else {
        channelBusy = props.wbsNetworkStatus.biddingCommBusy || props.wbsNetworkStatus.chatCommBusy; // either channel is busy
    }

    return channelBusy ? <div className="overlay-busy" style={{ display: channelBusy ? 'block' : 'none'}} /> : null;
};

NetworkAwareBusyOverlayCmp.defaultProps = {
    wbsCommChannel: ChannelEnum.bidding,
};



export default connect(({ activeWebcast }:ReduxStateType) => {
    return {
        wbsNetworkStatus: activeWebcast.wbsNetworkStatus
    };
})(NetworkAwareBusyOverlayCmp);

